import environment from '_environments'
export const apis = environment.apis
